// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Intro_breadcrumbs__-tePZ"};